import styled from "styled-components/macro";

export const PresenterImage = styled.img({
  width: "100%",
  height: "auto",
});

export const BannerContent = styled.div({
  display: "flex",
  alignContent: "center",
  height: "100%",
  flexWrap: "wrap",
});

export default styled.section({});
